// extracted by mini-css-extract-plugin
module.exports = {"title":"NTr57S"};